
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 75 60"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2575"}},[_c('g',{attrs:{"data-name":"Group 2574","transform":"translate(-279 -289)"}},[_c('g',{attrs:{"data-name":"Rectangle 2419","transform":"translate(279 289)","fill":"#1B342C","stroke":"#1BB58B","stroke-width":"3"}},[_c('rect',{attrs:{"width":"75","height":"60","rx":"10","stroke":"none"}}),_c('rect',{attrs:{"x":"1.5","y":"1.5","width":"72","height":"57","rx":"8.5","fill":"none"}})]),_c('rect',{attrs:{"data-name":"Rectangle 3249","width":"73.47","height":"6","rx":"3","transform":"translate(280.002 307.001)","fill":"#1BB58B"}}),_c('rect',{attrs:{"data-name":"Rectangle 3250","width":"24.491","height":"6","rx":"2","transform":"translate(289.716 328.001)","fill":"#42ddb3"}})])])])
          )
        }
      }
    